import { render, staticRenderFns } from "./YeastarPSeriesLinkToTask.vue?vue&type=template&id=5bd03328&scoped=true"
import script from "./YeastarPSeriesLinkToTask.vue?vue&type=script&lang=js"
export * from "./YeastarPSeriesLinkToTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd03328",
  null
  
)

export default component.exports